<template>
	<div :style="{ 'max-width': maxWidth }" class="progressBar">
		<div :style="style" class="progress"></div>
	</div>
</template>

<script>
export default {
	name: 'ProgressBar',
	props: {
		maxWidth: {
			type: String,
			required: false,
			default: '100%',
		},
		progress: {
			type: Number,
			required: true,
			default: 0,
		},
	},
	computed: {
		style: function() {
			return {
				width: `${this.progress}%`,
			};
		},
	},
};
</script>

<style lang="less" scoped>
.progressBar {
	background: white;
	width: 100%;
	height: 42px;
	box-sizing: border-box;
	border: solid 1px #f4f4f4;
	padding: 3px;
	border-radius: 9px;
	overflow: hidden;
	.progress {
		display: block;
		width: 0px;
		border-radius: 9px;
		height: 100%;
		background: #2aacea;
		background: linear-gradient(270deg, #2a82e9 0%, #2aace9 51.56%, #2ad2e9 100%);
		transition: 1000ms ease-in-out;
		position: relative;
		&::before {
			content: '';
			position: absolute;
			width: 100%;
			height: 100%;
			background-color: transparent;
			background-image: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23000000' fill-opacity='0.07' fill-rule='evenodd'%3E%3Cpath d='M0 40L40 0H20L0 20M40 40V20L20 40'/%3E%3C/g%3E%3C/svg%3E");
			background-repeat: repeat;
		}
	}
}
</style>
